export default __webpack_public_path__ + "static/media/aboutMain.e53dd0c0.jpeg";